import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import store from "./Redux/store";
import { Provider } from "react-redux";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


/*En resumen, este código configura el punto de entrada de la aplicación React, 
importa el componente App, crea una instancia del store de Redux y utiliza el 
componente Provider para proporcionar el store a la aplicación. Luego, se llama 
a ReactDOM.render para renderizar la aplicación en el punto de montaje especificado en el documento HTML.*/

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,

  document.getElementById("root")
);
